import { render, staticRenderFns } from "./TagCreateForm.vue?vue&type=template&id=23764d91&scoped=true&"
import script from "./TagCreateForm.vue?vue&type=script&lang=js&"
export * from "./TagCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./TagCreateForm.vue?vue&type=style&index=0&id=23764d91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23764d91",
  null
  
)

export default component.exports